const section = {
    about: '关于我',
    projects: '项目',
    blogs: '博客',
    skills: '技能',
    contact: '联系我 🤙',
    projectDetails: '详情',
    seeMoreGithub: '在 GitHub 上查看更多',
    moreArticle: '更多文章',
    downloadResume: '下载简历',
};

export default section;
